__turbopack_context__.v({
  "buttonBg": "RecipesList-module-scss-module__MGGZ8G__buttonBg",
  "fade-in": "RecipesList-module-scss-module__MGGZ8G__fade-in",
  "filterSelect": "RecipesList-module-scss-module__MGGZ8G__filterSelect",
  "inner": "RecipesList-module-scss-module__MGGZ8G__inner",
  "landscape": "RecipesList-module-scss-module__MGGZ8G__landscape",
  "listItem": "RecipesList-module-scss-module__MGGZ8G__listItem",
  "loadButton": "RecipesList-module-scss-module__MGGZ8G__loadButton",
  "noResults": "RecipesList-module-scss-module__MGGZ8G__noResults",
  "root": "RecipesList-module-scss-module__MGGZ8G__root",
  "transition": "RecipesList-module-scss-module__MGGZ8G__transition",
  "truncated": "RecipesList-module-scss-module__MGGZ8G__truncated",
});
